import { APIModel } from '@/src/models/api-model';

export class ItemType extends APIModel {
  id: string;
  item_type: string;

  static fieldsToMap = {
    direct: [
      'id',
      'item_type'
    ]
  }

  static buildFromAPI(record: any): ItemType {
    const row = new ItemType();
    record = record || {};

    this.mapFieldsDirectly<ItemType>(ItemType.fieldsToMap.direct, record, row);

    return row
  }
}